import {Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {LayoutService} from "./service/app.layout.service";
import {filter, Subscription} from "rxjs";
import {NavigationEnd, Router} from "@angular/router";
import {AppSidebarComponent} from "./app.sidebar.component";

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopbarComponent implements OnInit, OnDestroy {
    isHome = false;
    isMobile = false;
    isScrolled = false;
    routerSub!: Subscription;

    @ViewChild('menubutton') menuButton!: ElementRef;
    @ViewChild(AppSidebarComponent) appSidebar!: AppSidebarComponent;

    constructor(
        public layoutService: LayoutService,
        public el: ElementRef,
        private router: Router) {
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
        this.updateScrollState();
    }

    @HostListener('window:resize', [])
    onWindowResize() {
        this.updateViewport();
    }

    ngOnInit() {
        this.updateViewport();
        this.detectRoute(this.router.url);
        this.routerSub = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: any) => {
            this.detectRoute(event.urlAfterRedirects);
        });
        this.updateScrollState();
    }

    onRightMenuClick(event: Event) {
        console.log('Right menu clicked', event);
        this.layoutService.showRightMenu(event); // Pasa el evento al servicio
    }

    ngOnDestroy() {
        this.routerSub?.unsubscribe();
    }

    private detectRoute(url: string) {
        this.isHome = url === '/';
        this.isScrolled = false; // reset scroll on route change
    }

    private updateViewport() {
        this.isMobile = window.innerWidth <= 767;
    }

    private updateScrollState() {
        if (!this.isHome) {
            this.isScrolled = false;
            return;
        }

        if (this.isMobile) {
            this.isScrolled = window.scrollY > 10;
            return;
        }

        const aboutSection = document.querySelector('.about-section') as HTMLElement | null;
        const triggerPoint = aboutSection ? aboutSection.offsetTop - 80 : 120;
        this.isScrolled = window.scrollY >= triggerPoint;
    }

    get topbarClass(): string {
        if (this.isHome && !this.isScrolled) return 'topbar-transparent';
        if (this.isHome && this.isScrolled) return 'topbar-green';
        return 'topbar-default';
    }
}
